export default __webpack_public_path__ + "static/media/Psalm23.59a36299.mp3";